module.exports = __webpack_public_path__ + "static/media/factory.191e2328.jpg";